module.exports = __webpack_public_path__ + "img/header.ba05d8d1.jpg";